<p-dialog modal="true" appendTo="body" [(visible)]="display" [resizable]="false" (onHide)="onDialogHide()"
  [style]="{'width': '1000px', 'minWidth': '1000px'}">

  <p-header>
    <span>Share Network</span>
  </p-header>

  <div>
    <div class="heading-text" style="text-align: center;">
      Select access level and users/groups to share with
    </div>

    <hr />

    <div style="margin-top: 15px; margin-bottom: 15px; text-align: center;">
      <label class="label-text" style="margin-right: 8px;">Share Access Level:</label>
      <select style="padding: 3.75px;" [(ngModel)]="accessType">
        <option value="view">View</option>
        <option value="edit">Edit</option>
      </select>
      <button pButton style="margin: 0px 10px 0px 10px !important;" label="Advanced..." (click)="editPrivileges()"></button>
      <share-type-info></share-type-info>
    </div>

    <hr />

    <div style="height: 40px;">
      <span class="label-text" style="display: inline-block; margin-left: calc(50% - 70px); padding-top: 5px;">Users To Share With</span>
      <button pButton icon="fa fa-plus-square-o" style="float: right;"
      label="Add User" class="add-button" (click)="addUsers()"></button>
    </div>

    @if (hasUserEntries) {
      <div style="padding-bottom: 10px;">
        <p-table #udt [value]="userEntries" [resizableColumns]="true"
          [scrollable]="true" scrollHeight="230px"
          styleClass="share-editor-users-table">
          <ng-template pTemplate="header">
            <tr>
              <th pResizableColumn pSortableColumn="username">
                Username
                <p-sortIcon field="username"></p-sortIcon>
              </th>
              <th pResizableColumn pSortableColumn="firstname">
                First Name
                <p-sortIcon field="firstname"></p-sortIcon>
              </th>
              <th pResizableColumn pSortableColumn="lastname">
                Last Name
                <p-sortIcon field="lastname"></p-sortIcon>
              </th>
              <th pResizableColumn pSortableColumn="type">
                Type
                <p-sortIcon field="type"></p-sortIcon>
              </th>
              <th class="uv-table-button-column-1">
              </th>
            </tr>
            <tr>
              <th>
                <input pInputText type="text" (input)="udt.filter($event.target.value, 'username', 'contains')"
                  style="width: 100%;">
                </th>
                <th>
                  <input pInputText type="text" (input)="udt.filter($event.target.value, 'firstname', 'contains')"
                    style="width: 100%;">
                  </th>
                  <th>
                    <input pInputText type="text" (input)="udt.filter($event.target.value, 'lastname', 'contains')"
                      style="width: 100%;">
                    </th>
                    <th>
                      <input pInputText type="text" (input)="udt.filter($event.target.value, 'type', 'contains')"
                        style="width: 100%;">
                      </th>
                      <th class="uv-table-button-column-1">
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData>
                    <tr [pSelectableRow]="rowData">
                      <td>
                        <span class="uv-table-value">{{rowData.username}}</span>
                      </td>
                      <td>
                        <span class="uv-table-value">{{rowData.firstname}}</span>
                      </td>
                      <td>
                        <span class="uv-table-value">{{rowData.lastname}}</span>
                      </td>
                      <td>
                        <span class="uv-table-value">{{rowData.type}}</span>
                      </td>
                      <td class="uv-table-button-column-1">
                        <button type="button" class="btn btn-danger uv-first-table-button" title="Remove this user"
                          (click)="removeUser(rowData.tag)">
                          <i class="pi pi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }

            @if (!hasUserEntries) {
              <div class="message-text">
                No users have been added
              </div>
            }

            <hr />

            <div style="height: 40px;">
              <span class="label-text" style="display: inline-block; margin-left: calc(50% - 75px); padding-top: 5px;">Groups To Share With</span>
              <button pButton icon="fa fa-plus-square-o" style="float: right;"
              label="Add Group" class="add-button" (click)="addGroups()"></button>
            </div>

            @if (hasGroupEntries) {
              <div style="padding-bottom: 10px;">
                <p-table #gdt [value]="groupEntries" [resizableColumns]="true"
                  [scrollable]="true" scrollHeight="230px"
                  styleClass="share-editor-groups-table">
                  <ng-template pTemplate="header">
                    <tr>
                      <th pResizableColumn pSortableColumn="groupname">
                        Name
                        <p-sortIcon field="groupname"></p-sortIcon>
                      </th>
                      <th pResizableColumn pSortableColumn="type">
                        Type
                        <p-sortIcon field="type"></p-sortIcon>
                      </th>
                      <th class="uv-table-button-column-1">
                      </th>
                    </tr>
                    <tr>
                      <th>
                        <input pInputText type="text" (input)="gdt.filter($event.target.value, 'groupname', 'contains')"
                          style="width: 100%;">
                        </th>
                        <th>
                          <input pInputText type="text" (input)="gdt.filter($event.target.value, 'type', 'contains')"
                            style="width: 100%;">
                          </th>
                          <th class="uv-table-button-column-1">
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-rowData>
                        <tr [pSelectableRow]="rowData">
                          <td>
                            <span class="uv-table-value">{{rowData.groupname}}</span>
                          </td>
                          <td>
                            <span class="uv-table-value">{{rowData.type}}</span>
                          </td>
                          <td class="uv-table-button-column-1">
                            <button type="button" class="btn btn-danger uv-first-table-button" title="Remove this group"
                              (click)="removeGroup(rowData.tag)">
                              <i class="pi pi-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                }

                @if (!hasGroupEntries) {
                  <div class="message-text">
                    No groups have been added
                  </div>
                }

                <user-selector [(visible)]="userSelectorVisible" header="Select users to add"
                  [minUsers]="1" [maxUsers]="1000000" format="compact"
                  [except]="excludedUserGuids" (onOk)="addSelectedUsers($event)">
                </user-selector>

                <group-selector [(visible)]="groupSelectorVisible" header="Select groups to add"
                  [minGroups]="1" [maxGroups]="1000000" format="compact"
                [except]="excludedGroupGuids" (onOk)="addSelectedGroups($event)"></group-selector>

                <share-privileges-editor [target]="privileges" [(display)]="privilegesEditorVisible">
                </share-privileges-editor>

              </div>

              <p-footer>
                <button type="button" pButton icon="fa fa-check" (click)="handleOK()" label="OK" [disabled]="!enableOK"></button>
                <button type="button" pButton icon="fa fa-close" (click)="handleCancel()" label="Cancel"></button>
              </p-footer>

            </p-dialog>
